import React, { FunctionComponent, useMemo } from 'react';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  autoSyncCircle: {
    backgroundColor: theme.palette.information.dark,
    borderRadius: '50%',
    position: 'absolute',
    padding: 4,
    animation:
      '$scaleIn 16s infinite cubic-bezier(0.5, 0.5, 0.81, 1.1), $opacity 16s infinite cubic-bezier(0.73, -0.27, 1, 0.99)'
  },
  '@keyframes scaleIn': {
    from: {
      transform: 'scale(0)'
    },
    to: {
      transform: 'scale(5)'
    }
  },
  '@keyframes opacity': {
    from: {
      opacity: 0.25
    },
    to: {
      opacity: 0
    }
  },
  animationContainer: {
    display: 'flex',
    width: theme.spacing(4),
    height: theme.spacing(4),
    alignItems: 'center',
    justifyContent: 'center'
  }
}));

const CircularAnimation: FunctionComponent = () => {
  const classes = useStyles();
  const renderCircles = useMemo(
    () =>
      Array.from({ length: 5 }).map((_, index) => (
        <div
          key={index}
          className={classes.autoSyncCircle}
          style={{ animationDelay: `-${index * 4}s` }}
          data-testid="circular-ring"
        ></div>
      )),
    [classes.autoSyncCircle]
  );
  return (
    <div
      data-testid="circular-animation"
      className={classes.animationContainer}
    >
      {renderCircles}
    </div>
  );
};

export default CircularAnimation;
